import React from 'react';
import { FullScreen, WhiteBox, ModalContentArea, ButtonListArea, ModalTitle, ModalDescription, ButtonStyle, CanceButtonStyle, LinkStyle, KakaoChatWrapper } from './style';

export default function CenterModal ({modalVisible, dataList, onComplete, onCancel, zIndex, showKakaoChatBtn=false}){
    
    if(!modalVisible) return null;
    return (
    <FullScreen zIndex={zIndex}>
        <WhiteBox>
            <ModalContentArea>
                {(dataList?.title && (<ModalTitle>{dataList['title']}</ModalTitle>))}
               <ModalDescription>{dataList?.description}</ModalDescription>

                <ButtonListArea>
                    {(onCancel !== null && onCancel !== undefined) && (<CanceButtonStyle onClick={onCancel}>{dataList?.cancelTxt ?  dataList.cancelTxt : '취소'}</CanceButtonStyle>)}
                    {dataList?.type === 'redirect' ? 
                        <LinkStyle to={dataList['path']}>{dataList?.confirmTxt ?  dataList.confirmTxt : '확인'}</LinkStyle> :
                        <ButtonStyle onClick={onComplete}>{dataList?.confirmTxt ?  dataList.confirmTxt : '확인'}</ButtonStyle>
                    }
                </ButtonListArea>
                {(showKakaoChatBtn === true) && (
                    <KakaoChatWrapper>
                        
                    </KakaoChatWrapper>
                )}
            </ModalContentArea>
        </WhiteBox>
    </FullScreen>
    );
}